/**
 * @ngdoc Directive
 * @name vrm-validation-password
 * @example
 *
 * <vrm-validation-password />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidationPassword', vrmValidationPassword);

    /* @ngInject */
    function vrmValidationPassword() {
        return {
            restrict: 'A',
            require: ['ngModel', '^^form'],
            scope: {
                vrmValidationPassword: '=',
            },
            link: link
        };

        function link($scope, $element, $attr, required) {
            const ngModel = required[0];
            const form = required[1];

            $scope.form = form;

            $scope.$watch(function() {
                return (ngModel.$touched || form.$submitted) && ngModel.$invalid;
            }, function(hasError) {
                $element.toggleClass('sg-error', hasError);
            });

            ngModel.$validators.password = (modelValue) => {
                modelValue = (modelValue === undefined || modelValue === null) ? '' : modelValue;
                const userInfo = $scope.vrmValidationPassword;

                // Attempt to get name and email straight from the form if possible, providing real-time
                // feedback. If not possible, use the given values if present.
                const name = form.name && form.name.$modelValue !== undefined && form.name.$modelValue !== null ?
                    form.name.$modelValue :
                    (userInfo ? userInfo.name : '');
                const email = form.email && form.email.$viewValue !== undefined && form.email.$viewValue !== null ?
                    form.email.$viewValue :
                    (userInfo ? userInfo.email : '');

                // Minimum length
                if (modelValue.length < 8) {
                    return false;
                }

                // Check letter, digit and special character
                if (modelValue.match(/[a-zA-Z]/) === null ||
                    modelValue.match(/[0-9]/) === null ||
                    modelValue.match(/[@_!#$%^&*()<>?\/|\-}{~:+=]/) === null) {
                    return false;
                }

                // Check substrings
                const illegalSubstrings = getAllSubstrings(name, 3);
                if (email !== '') {
                    illegalSubstrings.push(email);
                }
                for (let i = 0; i < illegalSubstrings.length; i++) {
                    if (modelValue.includes(illegalSubstrings[i])) {
                        return false;
                    }
                }
                return true;
            };

            $scope.$watchGroup(['form.name.$modelValue', 'form.email.$viewValue', 'vrmValidationPassword'], () => {
                if (ngModel.$dirty) {
                    ngModel.$validate();
                }
            });
        }

        function getAllSubstrings(string, minLength) {
            const substrings = [];
            const characterArray = string.split('');
            // All possible starting positions of a substring
            for (let position = 0; position <= characterArray.length - minLength; position++) {
                // All possible lengths of a substring with this starting position
                for (let length = minLength; length <= characterArray.length - position; length++) {
                    const currentSubstring = characterArray.slice(position, position + length).join('');
                    if (currentSubstring !== '') {
                        substrings.push(currentSubstring);
                    }
                }
            }
            return substrings;
        }
    }
})();
